import { render, staticRenderFns } from "./OChat.vue?vue&type=template&id=46f4911a&"
import script from "./OChat.vue?vue&type=script&lang=ts&"
export * from "./OChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports